/**
 * @flow
 * @relayHash fb26165588e9d6b993c6d1107fc47216
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type authorizeTokenQueryVariables = {||};
export type authorizeTokenQueryResponse = {|
  +viewer: ?{|
    +isUserTokenValid: ?boolean
  |}
|};
export type authorizeTokenQuery = {|
  variables: authorizeTokenQueryVariables,
  response: authorizeTokenQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isUserTokenValid",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "authorizeTokenQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "authorizeTokenQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "authorizeTokenQuery",
    "id": "dibs-buyer-layout/222.6.0-2019-06-25T11:58:43.302Z/authorizeTokenQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8b60fc748be9b1da275f7e090fc551e5';
module.exports = node;
